module.exports = __webpack_public_path__ + "static/media/music_background.1a8f8135.mp3";